import {apiConfig} from "./apiConfig";
import {storeProTypeID} from "./storeProTypeID";
import {progressBarDisplay} from "./progressBarDisplay";
// import {setText} from "./setText";
// import { animation } from "./refreshScheduleData"; 
var currentRequest:any = 'ToCancelPrevReq';
export function serviceSearchTermApi(search_term:any,serviceType:any,webLocationId:any,searchServiceFlag:any){
    $(".servicesListDropdown").empty();
    if(search_term != ""){
        currentRequest = $.ajax({
            url:apiConfig.serviceAggregatesWeblocation+webLocationId+'/service-search-term-aggregates/search?apikey='+window.DEFINE_VALUE.JS_API_KEY+'&search_term='+search_term+'&service_modifier='+serviceType+'&postal_code='+window.objOSGlobal.requestBodyValues.PostalCode+'&skip=0&take=10',
            type: 'GET',
            dataType: 'json',
            contentType: "application/json",
            beforeSend: function(xhr){
                if (currentRequest != null  && currentRequest.readyState < 4){
                    currentRequest.abort();
                }
            },
            success:function(response){
                let len = response.length;
                $(".servicesListDropdown").empty();
                for( let i = 0; i<len; i++){
                    let serviceSkuId = response[i]['serviceSkuId'];
                    let name = response[i]['name'];
                    let serviceId = response[i]['serviceId'];
                    $(".servicesListDropdown").append("<li id ='"+serviceId+"'  value='"+serviceSkuId+"'><a href='#'>"+name+"</a></li>");
                }
                $(".servicesListDropdown li a").bind("click",function(this:any,e:any){
                    e.preventDefault();
                    // setText(this);
                    let serviceSkuId =$(this).parent().val();
                    let serviceId = $(this).parent().attr('id');
                    let serviceName = $(this).text();
                    window.objOSGlobal.requestBodyValues.serviceSkuId = serviceSkuId
                    window.objOSGlobal.requestBodyValues.ServiceId = serviceId
                    window.objOSGlobal.requestBodyValues.ServiceSkuIds = [serviceSkuId];
                    window.objOSGlobal.requestBodyValues.serviceName = serviceName;
                    storeProTypeID(serviceSkuId);
                    progressBarDisplay()
                });
            },
            error:function(error){
            }
        });
        $('.js-servicesListDropdown').show();
    }else{
        $('.js-servicesListDropdown').hide();
    }
}